import { render, staticRenderFns } from "./RenderOnboarding.vue?vue&type=template&id=55eb3932"
import script from "./RenderOnboarding.vue?vue&type=script&lang=js"
export * from "./RenderOnboarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports